import { render, staticRenderFns } from "./Specsavers.vue?vue&type=template&id=0f0ca291"
import script from "./Specsavers.vue?vue&type=script&lang=js"
export * from "./Specsavers.vue?vue&type=script&lang=js"
import style0 from "./Specsavers.vue?vue&type=style&index=0&id=0f0ca291&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports